import React from 'react';
import { Delete, Edit } from '@mui/icons-material';
import { Box, Button, Grid, Typography } from '@mui/material';
import { colors } from '../../assets/utils/colors';
import CustomCard2 from '../cards/CustomCard2';
import CustomDialogy from '../dialogys/CustomDialogy';
import BrandWidget2 from '../widgets/BrandWidget2';
import UpdateBrand from '../../pages/brands/UpdateBrand';
import moment from 'moment';

// !############### MAIN FUNC ####################
const BrandDetailsSidebar = ({ brand }) => {
  const [openDialogy, setOpenDialogy] = React.useState(false);
  const handleOpenDialogy = () => {
    setOpenDialogy(true);
  };
  const handleCloseDialogy = () => {
    setOpenDialogy(false);
  };
  return (
    <>
      {/* ############### Dialogy ################# */}
      <CustomDialogy
        title={'Update brand'}
        open={openDialogy}
        handleCloseDialogy={handleCloseDialogy}
      >
        <UpdateBrand />
      </CustomDialogy>

      {/* ################ Main Content ################ */}
      <CustomCard2 title={'Brand actions'} height={630}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item sm={12}>
            <BrandWidget2 brand={brand} />
          </Grid>
        </Grid>

        <Box sx={{}}>
          <Grid container justifyContent={'center'} spacing={3} paddingTop={3}>
            <Grid item sm={11}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                  p: 2,
                  background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                  borderRadius: 4,
                }}
              >
                <Typography
                  sx={{
                    py: 1,
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: colors.primary,
                  }}
                >
                  Brand descriptions
                </Typography>
                <Box>
                  <Typography sx={{ fontSize: 13 }}>
                    {brand.brand_description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item sm={11}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 'bold',
                    color: colors.primary,
                  }}
                >
                  Created on
                </Typography>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 'bold',
                    color: colors.primary,
                  }}
                >
                  {moment(brand.created_at).format('ll')}
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={11}>
              <Box sx={{ display: 'flex' }}>
                <Button
                  startIcon={<Edit />}
                  color="warning"
                  className="app-btn"
                  variant="contained"
                  fullWidth
                  sx={{
                    m: 1,
                  }}
                  onClick={() => handleOpenDialogy()}
                >
                  Edit
                </Button>
                <Button
                  startIcon={<Delete />}
                  color="error"
                  className="app-btn"
                  variant="contained"
                  fullWidth
                  sx={{
                    m: 1,
                  }}
                >
                  Delete
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </CustomCard2>
    </>
  );
};

export default BrandDetailsSidebar;
